import Link from "components/atoms/Link";
import colors from "constants/colors";
import React from "react";
import styled, { css } from "styled-components/macro";
import { joinClassnames } from "utils/map-modifier";
import { isExternal } from "utils/utils-common";
import "./index.scss";

interface FrameImageProps {
  link?: string;
  src: string;
  /**
   * ratio prop is a number from 0 to 1
   */
  ratio: number;
  /**
   * mask prop to use or not the background to fill the image
   */
  mask?: boolean;
  /**
   * zoom prop to use or not zooming when you hover on the image
   */
  zoom?: boolean;
  className?: string;
  frameImageClassName?: string;
}

const FrameImage: React.FC<FrameImageProps> = ({
  children,
  link,
  src,
  ratio,
  mask,
  zoom,
  className,
  frameImageClassName,
}) => {
  return link ? (
    <Link
      className={joinClassnames("m-frame-image__link", className)}
      href={link}
      isLinkRouter={!isExternal(link)}
      target={Boolean(isExternal(link))}
    >
      <FrameImageContainer
        src={src}
        ratio={ratio}
        mask={mask ? mask.toString() : ""}
        zoom={Boolean(zoom)}
        className={joinClassnames("m-frame-image__image", frameImageClassName)}
      >
        <BackgroundImage src={src} />
        {children}
      </FrameImageContainer>
    </Link>
  ) : (
    <FrameImageContainer
      src={src}
      ratio={ratio}
      mask={mask ? mask.toString() : ""}
      zoom={Boolean(zoom)}
      className={joinClassnames("m-frame-image__image", frameImageClassName)}
    >
      <BackgroundImage src={src} />
      {children}
    </FrameImageContainer>
  );
};

FrameImage.defaultProps = {};

type BackgroundImageType = {
  src: string;
};
const BackgroundImage = styled.div<BackgroundImageType>`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  transition: 2s;
  transform: translate(-50%, -50%) scale(1);
  background: url("${({ src }) => src}") no-repeat center center / cover;
`;

type FrameImageContainerType = {
  src: string;
  ratio: number;
  mask?: string;
  zoom: boolean;
};
const FrameImageContainer = styled.div<FrameImageContainerType>`
  position: relative;

  &:before {
    content: "";
    display: block;
    padding-bottom: ${({ ratio }) => ratio * 100}%;
  }

  ${({ mask }) =>
    mask === "true" &&
    css`
      &:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: ${colors.raisinBlack};
        border-radius: 3px;
        opacity: 0;
        transition: 0.45s;
      }

      &:hover {
        ${BackgroundImage} {
          transform: translate(-50%, -50%) scale(1.05);
        }

        &:after {
          opacity: 0.25;
        }
      }
    `};

  ${({ zoom }) =>
    zoom &&
    css`
      &:hover {
        ${BackgroundImage} {
          transform: translate(-50%, -50%) scale(1.05);
        }
        & + .m-cardlink_wrap {
          &:before {
            width: 100%;
          }
        }
      }
    `};
`;

export default FrameImage;
